import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { CardPaymentDetails } from "./cardPaymentDetails"
import {
  CardPaymentStatus,
  ICardPaymentDetails,
  JuniferPaymentStatus,
  PaymentNotificationStatus,
} from "./cardPaymentDetails.types"

export interface ICardPaymentDetailsRaw {
  status: string
  notification_status: string
  junifer_payment_status: string
  amount: number
  reference: string
  error_code?: string | null
  error_message?: string | null
  notification_error?: string | null
}

export const CardPaymentDetailsParser: IParser<
  ICardPaymentDetails,
  ICardPaymentDetailsRaw
> = {
  toDomain: (data: ICardPaymentDetailsRaw): ICardPaymentDetails => {
    try {
      if (!(data.status in CardPaymentStatus))
        throw new Error("Invalid status value")

      if (!(data.notification_status in PaymentNotificationStatus))
        throw new Error("Invalid notification_status value")

      if (!(data.junifer_payment_status in JuniferPaymentStatus))
        throw new Error("Invalid junifer_payment_status value")

      return new CardPaymentDetails(
        data.status as CardPaymentStatus,
        data.notification_status as PaymentNotificationStatus,
        data.junifer_payment_status as JuniferPaymentStatus,
        data.amount,
        data.reference,
        data.error_code ?? undefined,
        data.error_message ?? undefined,
        data.notification_error ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
